import { render, staticRenderFns } from "./AddActivoPage.vue?vue&type=template&id=7b92cc66"
import script from "./AddActivoPage.vue?vue&type=script&lang=js"
export * from "./AddActivoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports